import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.confirmIdeal.steps.accountName.title',
    defaultMessage: 'Account holder name',
    description: 'title of the confirmed step of the confirm ideal page',
  },
  description: {
    id: 'pages.confirmIdeal.steps.accountName.description',
    defaultMessage:
      'to activate direct debit payments, we need you to fill out the name of the owner of the account ending with {last4}.',
    description: 'description of the confirmed step of the confirm ideal page',
  },
  fields: {
    accountHolderName: {
      id: 'properties.accountHolderName',
      defaultMessage: 'Account holder name',
      description: 'label of the account holder field',
    },
  },
  mandateMessage: {
    id: 'pages.contract.paymentMethods.mandateMessage',
    defaultMessage:
      'By providing your IBAN and confirming this payment, you are authorizing Afosto SaaS b.v. and Stripe, our payment service provider, to send instructions to your bank to debit your account and your bank to debit your account in accordance with those instructions. You are entitled to a refund from your bank under the terms and conditions of your agreement with your bank. A refund must be claimed within 8 weeks starting from the date on which your account was debited.',
    description: '',
  },
  actions: {
    back: {
      id: 'actions.back',
      defaultMessage: 'Back',
      description: 'label of the back button',
    },
    activate: {
      id: 'actions.activate',
      defaultMessage: 'Activate',
      description: 'label of the activate button',
    },
  },
  feedback: {
    accountConfirmed: {
      id: 'pages.confirmIdeal.feedback.accountConfirmed',
      defaultMessage: 'Account confirmed, payment method saved',
      description: 'feedback on the successful confirmation of the account',
    },
    accountNotConfirmed: {
      id: 'pages.confirmIdeal.feedback.accountNotConfirmed',
      defaultMessage: 'Account not confirmed, payment method not saved',
      description: 'feedback on the failed confirmation of the account',
    },
  },
};

export default defineMessages(translations);
